export default "__VITE_ASSET__6Phms_i1__"